var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-bookmarks"},[_c('div',{staticClass:"item-bookmarks"},[_c('feather-icon',{attrs:{"icon":"ImageIcon","color":"#ff9f43","size":"18"}}),_c('p',{staticClass:"mb-0 ml-1"},[_vm._v("Ver galeria")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }